import { Navigate, Outlet } from "react-router-dom";
import { HeaderBar } from "../Header";
import { Footer } from "../Footer";
import { Box } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../redux/hooks";

export const LayoutAuthRanking: React.FC<{}> = () => {
    const { isAuth } = useAppSelector((state) => state.authReducer);
    console.log(isAuth);

    if (!isAuth) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1100 }}>
                <HeaderBar />
            </Box>

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    mt: { xs: 16, md: 12 },
                    mb: 4,
                 }}
            >
                <Outlet />
            </Box>

            <Footer />
        </Box>
    );
};